import React, { useState, useEffect } from 'react'
import { Card, CardContent, CardHeader } from '@mui/material'
import { makeStyles } from '@mui/styles'
import { useDataProvider } from 'react-admin'
import BaseOneEntityChart from './components/BaseOneEntityChart'

const useStyles = makeStyles(() => ({
  customCard: {
    marginBottom: '1rem',
  },
  section: {
    marginBottom: '1rem',
  },
}))

export const Dashboard = () => {
  const classes = useStyles()
  const dataProvider = useDataProvider()
  const [UsersTotal, setUsersTotal] = useState(0)
  const [UsersChartData, setUsersChartData] = useState([])
  const [OrdersTotal, setOrdersTotal] = useState(0)
  const [OrdersChartData, setOrdersChartData] = useState([])

  const fetchTotal = async (resource, setTotal) => {
    try {
      const { total } = await dataProvider.getList(resource, {
        pagination: { page: 1, perPage: 10 },
        sort: { field: 'createdAt', order: 'DESC' },
        // UNDEFINED_VARIABLE,
      })
      setTotal(total)
    } catch (error) {
      console.error(`Error fetching total for ${resource}:`, error)
    }
  }

  const fetchChartData = async (resource, setChartData, label) => {
    try {
      const { data } = await dataProvider.getList(resource, {
        pagination: { page: 1, perPage: 0 },
        sort: { field: 'createdAt', order: 'ASC' },
        // UNDEFINED_VARIABLE,
      })

      let cumulativeTotal = 0
      const chartData = []
      const groupedData = {}

      data.forEach((item) => {
        const date = new Date(item.createdAt).toLocaleDateString('en-CA')
        groupedData[date] = (groupedData[date] || 0) + 1
      })

      for (const date in groupedData) {
        cumulativeTotal += groupedData[date]
        chartData.push({ date, [label]: cumulativeTotal })
      }

      setChartData(chartData)
    } catch (error) {
      console.error(`Error fetching chart data for ${resource}:`, error)
    }
  }

  useEffect(() => {
    fetchTotal('Users', setUsersTotal)
    fetchChartData('Users', setUsersChartData, 'Users')
    fetchTotal('Orders', setOrdersTotal)
    fetchChartData('Orders', setOrdersChartData, 'Orders')
  }, [dataProvider])

  return (
    <>
      <div className={classes.section}>
        <Card>
          <CardHeader title="Welcome to the administration" />
          <CardContent>
            PublishKit is a platform for creating, selling, and delivering digital products:
            books, programs, and tools - directly to your audience
          </CardContent>
        </Card>
      </div>

      <Card>
        <CardHeader title={`Users Total: ${UsersTotal}`} />
        <BaseOneEntityChart
          data={UsersChartData}
          index="date"
          categories={['Users']}
          colors={['#3b82f6']}
        />
      </Card>
      <Card>
        <CardHeader title={`Orders Total: ${OrdersTotal}`} />
        <BaseOneEntityChart
          data={OrdersChartData}
          index="date"
          categories={['Orders']}
          colors={['#10b981']}
        />
      </Card>
    </>
  )
}
